import React from "react";
import * as CHQ from "chq";

import { ProfileLink, RecognitionLink } from "app/links";
import { Trans } from "app/utils";

import NotificationBody from "./NotificationBody";

type RecognitionUserListProps = {
  users: CHQ.User[];
  tabIndex?: number;
};

const RecognitionUserList: React.FC<RecognitionUserListProps> = ({ users, tabIndex }) => {
  switch (users.length) {
    case 1:
      return <ProfileLink user={users[0]} tabIndex={tabIndex || 0} />;
    case 2:
      return (
        <Trans>
          <ProfileLink user={users[0]} tabIndex={tabIndex || 0} />
          {" "}
          and
          {" "}
          <ProfileLink user={users[1]} tabIndex={tabIndex || 0} />
        </Trans>
      );
    default:
      return (
        <Trans>
          <ProfileLink user={users[0]} tabIndex={tabIndex || 0} /> and {users.length - 1} others
        </Trans>
      );
  }
};

type RecognitionGivenCheeredNotificationProps = {
  notification: CHQ.NotificationRecognitionGivenCheered;
  tabIndex?: number;
};

const RecognitionGivenCheeredNotification: React.FC<RecognitionGivenCheeredNotificationProps> = ({
  notification: { actor, entity }, tabIndex
}) => (
  <NotificationBody actor={actor}>
    <ProfileLink user={actor} tabIndex={tabIndex || 0} />
    {" "}
    <Trans>
      cheered the
      {" "}
      <RecognitionLink recognition={entity.cheerable} tabIndex={tabIndex || 0}>
        recognition
      </RecognitionLink>
      {" "}
      you gave to
    </Trans>
    {" "}
    <RecognitionUserList users={entity.cheerable.users} />
  </NotificationBody>
);

export default RecognitionGivenCheeredNotification;
